import { Tabs, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { ProjectConfig } from "Global";

export interface Lang {
  lang_id: string;
  lang: string;
}

interface LangTabsProps {
  currentLangId: string;
  onChange: (langId: string) => void;
}

export default function LangTabs({ currentLangId, onChange }: LangTabsProps) {
  const [langs, setLangs] = useState<Lang[]>([]);

  // Cargar idiomas
  useEffect(() => {
    axios
      .get(ProjectConfig.api_url, { params: { request: "lang_list_simple" } })
      .then((res) => {
        // lang_list_simple devuelve un array directo
        if (Array.isArray(res.data)) {
          setLangs(res.data);
        } else if (res.data.lang_list) {
          // Fallback por si se usa lang_list
          setLangs(res.data.lang_list);
        }
      })
      .catch((err) => console.error("Error loading langs:", err));
  }, []);

  // Notificar al padre cuando cambia el idioma
  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    onChange(newValue);
  };

  if (langs.length === 0) return null;

  return (
    <Tabs
      value={currentLangId}
      onChange={handleChange}
      sx={{ marginBottom: 2, borderBottom: 1, borderColor: "divider" }}
    >
      {langs.map((lang) => (
        <Tab key={lang.lang_id} label={lang.lang} value={String(lang.lang_id)} />
      ))}
    </Tabs>
  );
}
